@use "variables" as *;

.checkbox {
  text-align: left;
}

.checkbox:not(:last-child) {
  margin-bottom: $spacing-2;
}
